import React from "react";

export default function XOR() {
  return <div>Excel_XOR</div>;
}
